var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox-with-terms"},[_c('Checkbox',{staticClass:"checkbox",attrs:{"name":_vm.name,"value":_vm.value},on:{"input":_vm.onChange}}),_c('label',{attrs:{"for":_vm.name}},[_c('p',{staticClass:"terms"},[_vm._v(_vm._s(_vm.terms))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }